<template>
  <div>
    <el-table v-loading="loading"
	    :data="tableData" border stripe>
	     <el-table-column
	     	fixed
	      prop="buyDate"
	      label="购买时间" min-width="120">
	    </el-table-column>
	    <el-table-column
	      prop="incomeAll"
	      label="总金额">
	    </el-table-column>
	    <el-table-column
	      prop="userName"
	      label="用户昵称">
	    </el-table-column>
	    <el-table-column
	      prop="buyCount"
	      label="购买次数">
	    </el-table-column>
	    <el-table-column
	      prop="buyFrom"
	      label="购买来源">
	    </el-table-column>
	  </el-table>
	  <el-pagination
			layout="prev, pager, next" :current-page="currentPage" @current-change="gettable"
			:total="resultCount" :page-size="10" :pager-count="5">
		</el-pagination>
  </div>
</template>

<script>
export default {
  name: 'user',
  data () {
    return {
      tableData: [],
      resultCount:1,
      currentPage:1,
      buyFrom:null,
      loading: true
    }
   },
    methods:{
    	gettable:function(currentPage){
    		var _this = this;
    		_this.currentPage=currentPage;
				$.ajax({
					type: "post",
					url: _this.$store.state.getUrl + "api/sell/getOrderInfoUserList",
					data: JSON.stringify({
						"pageNo": currentPage,
						"count": 10,
						"buyFrom": _this.buyFrom,
						"token": _this.$store.getters.getStorage
					}),
					dataType: "json",
					crossDomain: true == !(document.all),
					contentType: "application/json",
					success: function(data) {
						_this.loading=false;
						if(data.ret == 10000) {
							_this.tableData=data.result.list;
							_this.resultCount=data.result.resultCount;
						} else {
							alert(data.status);
							_this.$router.push({path:'/login'});
							Vue.prototype.$message.warning('登录信息过期，请重新登录！')
						}
					}
				});
    	}
    },
    mounted:function(){
    	var _this=this;
    	if(_this.$route.query.val){
    		var val=decodeURIComponent(_this.$route.query.val);
    		if(val=='全部'){
    			_this.buyFrom=null;
    		}else{
    			_this.buyFrom=val;
    		}  		
    	}   	
    	_this.gettable(1);
    },
    watch: {
	  '$route' (to, from) { //监听路由是否变化
		  if(to.query.val != from.query.val){
		  	Object.assign(this.$data, this.$options.data()) //初始化数据
		  	var val=decodeURIComponent(this.$route.query.val);
		  	console.log(val)
    		if(val=='全部'){
    			this.buyFrom=null;
    		}else{
    			this.buyFrom=val;
    		}  		
		  	this.gettable(1);
		  }
	  }
    },
	beforeRouteEnter (to, from, next) {
    if (to.matched.some(m => m.meta.auth)) {
	    if (window.localStorage.isLogin === '1') {
	      next()
	    } else{
	      next({path: '/login'})
	      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
	    }
	  } else {
	    next()
	  }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user.vue